/* ─── FAQ page — wrapper (standalone layout matching other static pages) ─── */

.pageWrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: var(--color-bg-primary);
}

.main {
  flex: 1;
}

/* ─── Language switcher ──────────────────────────────────────────────────── */

.langSwitcher {
  display: flex;
  gap: 6px;
  margin-bottom: 20px;
}

.langBtn {
  background-color: transparent;
  color: var(--color-text-muted);
  border: 1px solid var(--color-border);
  border-radius: 4px;
  padding: 4px 10px;
  font-size: 0.8rem;
  font-family: inherit;
  font-weight: 600;
  letter-spacing: 0.04em;
  cursor: pointer;
  transition: background-color 0.15s, color 0.15s, border-color 0.15s;
}

.langBtn:hover {
  border-color: var(--color-accent);
  color: var(--color-accent);
}

.langBtnActive {
  background-color: var(--color-accent);
  border-color: var(--color-accent);
  color: var(--color-text-inverse);
  cursor: default;
}

.langBtnActive:hover {
  background-color: var(--color-accent);
  color: var(--color-text-inverse);
}

/* ─── Expand / collapse controls ─────────────────────────────────────────── */

.faqControls {
  display: flex;
  gap: 10px;
  margin-bottom: 24px;
}

.faqControlButton {
  background-color: var(--color-accent-subtle);
  color: var(--color-accent);
  border: 1px solid var(--color-accent);
  border-radius: 6px;
  padding: 9px 18px;
  font-size: 0.9rem;
  font-family: inherit;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
  white-space: nowrap;
}

.faqControlButton:hover {
  background-color: var(--color-accent);
  color: var(--color-text-inverse);
}

.faqList {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.faqItem {
  border: 1px solid var(--color-border);
  border-radius: 8px;
  background-color: var(--color-bg-card);
  box-shadow: var(--color-shadow-card);
  transition: border-color 0.2s, background-color 0.2s, border-width 0.2s;
  scroll-margin-top: 80px; /* clear sticky MenuBar */
}

/* Highlight when navigated to via URL hash */
.faqItem:target {
  border-color: var(--color-accent);
  background-color: var(--color-accent-subtle);
}

/* Emphasize when expanded */
details[open].faqItem {
  border: 2px solid var(--color-accent);
  background-color: var(--color-accent-subtle);
}

.faqQuestion {
  list-style: none;
  padding: 18px 20px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  color: var(--color-text-primary);
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  transition: color 0.2s;
}

/* Emphasize question text when expanded */
details[open] > .faqQuestion {
  color: var(--color-accent);
}

.faqQuestion::-webkit-details-marker {
  display: none;
}

/* Custom expand/collapse indicator */
.faqQuestion::after {
  content: '▸';
  font-size: 0.8rem;
  color: var(--color-text-muted);
  flex-shrink: 0;
  transition: transform 0.2s, color 0.2s;
}

details[open] > .faqQuestion::after {
  transform: rotate(90deg);
  color: var(--color-accent);
}

.faqAnswer {
  padding: 0 20px 20px;
  font-size: 0.95rem;
  line-height: 1.7;
  color: var(--color-text-secondary);
  border-top: 1px solid var(--color-border);
}

.faqAnswer a {
  color: var(--color-accent);
  text-decoration: underline;
}

.faqAnswer a:hover {
  text-decoration: none;
}

.faqAnswer p:first-child {
  margin-top: 16px;
}

.faqAnswer p:last-child {
  margin-bottom: 0;
}
